import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9e0edae0&scoped=true"
import script from "./LanguageSelect.js?vue&type=script&lang=js&external"
export * from "./LanguageSelect.js?vue&type=script&lang=js&external"
import style0 from "./styles.scss?vue&type=style&index=0&id=9e0edae0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0edae0",
  null
  
)

export default component.exports